import { connect } from "react-redux"

import SystemMigration from '../SystemMigration'

import {migrationEntityActions, migrationListActions} from '../../../../js/actions/index'

class Cppro extends SystemMigration {
    constructor() {
        super()
        this.state = {
            headers: ["Namespace", "Processos", "Contatos sem processo", "Inicio", "Fim", "Ambiente", "Status", ""],
            defaultValues: {
                SQLSERVER: {sqlFolder: '/sql/cppro/sqlserver', encoding: 'WIN1252'},
                DATABASES: [{label: 'SQL Server', value: 'SQLSERVER'}],
                ORIGIN: 'CPPRO',
                NAME: 'Cppro'
            }
        }
    }
}

const mapStateToProps = state => {
    return {
        newMigration: state.migrationEntityReducer.entity,
        list: state.migrationsListReducer.cppro.filtered
    }
}

const mapDispatchToProps = dispatch => {
    return {
        update: migrationEntity => dispatch(migrationEntityActions.updateMigrationEntity(migrationEntity)),
        clear: () => dispatch(migrationEntityActions.clearMigrationEntity()),
        showAll: () => dispatch(migrationListActions.showAllCpproMigrations())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cppro);



// WEBPACK FOOTER //
// ./src/views/components/systems/cppro/Cppro.js